'use strict';

var moveSelection = require('./transforms/moveSelection');

function onUpDown(event, data, state, opts) {
    var transform = state.transform();

    var newTransform = moveSelection(opts, transform, 0, data.key === 'up' ? -1 : +1);

    if (newTransform !== transform) {
        event.preventDefault();
    }

    return newTransform.apply();
}

module.exports = onUpDown;


//////////////////
// WEBPACK FOOTER
// ./~/slate-edit-table/dist/onUpDown.js
// module id = 685
// module chunks = 0